import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import moment from 'moment';
import Countdown from 'react-countdown';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import MarkingSchema from '../../../../components/MarkingSchema';
import GeneralInstruction from '../../../../components/GeneralInstruction';
import '../../../../css/upcomingTest.css';
import Header from '../../../../components/Header';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import FileUploadIcon from '../../../../svg/FileUploadIcon';
import UploadSolution from './Student.UploadSolution';
import InAppTest from './Student.InAppTest';
import Iconify from '../../../../fl-components/Iconify';

export default function UpcomingTestDetails({ testDetails, onBack }) {
  const {
    name,
    startDate,
    createdAt,
    startTime,
    type,
    duration,
    totalMark,
    correctMark,
    incorrectMark
  } = testDetails;
  const [selectedScreen, setSelScreen] = useState(null);
  // Test modal
  const [instructionModal, setInstructionModal] = useState(false);
  // test started
  const [testStarted, setTestStarted] = useState(false);

  useEffect(() => {
    setTestStarted(moment().isAfter(startTime));
  }, [testDetails]);

  return (
    <div style={{ marginTop: 20 }}>
      {/* eslint-disable-next-line */}
      {selectedScreen === null ? (
        <>
          <div className="nameAndActionContainer">
            <Header title={name} onBack={onBack} sx={{ marginBottom: 0 }} noMargin />
            {!testStarted && (
              <div
                style={{
                  borderRadius: 50,
                  backgroundColor: palette.secondary.main,
                  color: 'white',
                  padding: 10,
                  fontSize: 12
                }}
              >
                <Countdown
                  date={moment(startTime).format()}
                  renderer={(props) => (
                    <Typography
                      m={0}
                      fontSize={12}
                      // p="10px"
                      color="white"
                      // eslint-disable-next-line react/prop-types
                    >{`Starts in ${props?.hours}:${props?.minutes}:${props?.seconds}`}</Typography>
                  )}
                  onComplete={() => setTestStarted(true)}
                />
              </div>
            )}
            {testStarted && type === 'upload' && (
              <div
                style={{
                  borderRadius: 50,
                  backgroundColor: '#17E21F',
                  color: 'white',
                  padding: 10,
                  fontSize: 12
                }}
              >
                Test Started
              </div>
            )}
            {testStarted && type === 'type' && !testDetails?.submissionId && (
              <Button variant="contained" onClick={() => setInstructionModal(true)}>
                Start Test
              </Button>
            )}
          </div>
          {/* {testStarted && type === 'type' && (
            <Card sx={{ marginTop: 2 }}>
              <CardHeader title="Start writting your solution here" />
              <CardContent>
                <NameAndChangeToScreenCard
                  title="Class Test"
                  icon={<WritingPageIcon color={palette.secondary.main} />}
                  onClick={() => setSelScreen('inApp')}
                />
              </CardContent>
            </Card>
          )} */}
          {testStarted && type === 'upload' && (
            <Card sx={{ marginTop: 2 }}>
              <CardHeader title="Download the test paper" />
              <CardContent>
                <DownloadFileContainer title={testDetails.typeURL} isDownload />
              </CardContent>
            </Card>
          )}
          <TestInfoCard
            createdOn={moment(createdAt).format('DD MMM, LT')}
            startTime={`${moment(startDate).format('DD MMM,')} ${moment(startTime).format('LT')}`}
            endTime={`${moment(startDate).format('DD MMM,')} ${moment(startTime)
              .add(duration, 'minutes')
              .format('LT')}`}
            duration={`${duration} minutes`}
            questions={
              // eslint-disable-next-line
              type === 'type'
                ? testDetails.questions.length
                : testDetails?.totalQuestions
                ? testDetails.totalQuestions
                : null
            }
            marks={totalMark}
          />
          <MarkingSchema
            correctAns={correctMark}
            incorrectAns={incorrectMark < 0 ? `-${incorrectMark}` : incorrectMark}
          />
          {testDetails?.description && (
            <GeneralInstruction instructionList={testDetails?.description.split(',')} />
          )}
          {testStarted && type === 'upload' && (
            <Card sx={{ marginTop: 2 }}>
              <CardContent>
                <NameAndChangeToScreenCard
                  title="Upload Solution"
                  icon={<FileUploadIcon color={palette.secondary.main} />}
                  onClick={() => setInstructionModal(true)}
                />
              </CardContent>
            </Card>
          )}
        </>
      ) : (
        <>
          {selectedScreen === 'upload' && <UploadSolution onBack={() => setSelScreen(null)} />}
          {selectedScreen === 'inApp' && (
            <InAppTest title={name} onBack={() => setSelScreen(null)} />
          )}
        </>
      )}

      <Dialog fullWidth open={instructionModal} onClose={() => setInstructionModal(false)}>
        <DialogTitle>
          Test Instruction
          <IconButton
            onClick={() => setInstructionModal(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <Iconify icon="ep:close-bold" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography mb={3}>
            Please read this following test details before starting the test. When you start test
            then you cannot stop it. If time is end then test will be automatic sent.
          </Typography>
          <Typography>
            Test name: <b>{name}</b>
          </Typography>
          <Typography>
            Test duration: <b>{duration} min</b>
          </Typography>
          {testDetails?.description && (
            <Typography>
              Test description: <b>{testDetails?.description}</b>
            </Typography>
          )}
          <Typography>
            Correct answer mark: <b>{correctMark}</b>
          </Typography>
          <Typography>
            Incorrect answer mark: <b>{incorrectMark}</b>
          </Typography>
          <Typography>
            Test total mark: <b>{totalMark}</b>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            variant="contained"
            onClick={() => {
              setInstructionModal(false);
              window.open(
                `${window.location.origin}/dashboard/in-app/test/${
                  testDetails?.id ?? testDetails?._id
                }`
              );
            }}
          >
            Start
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

UpcomingTestDetails.propTypes = {
  testDetails: PropTypes.object,
  onBack: PropTypes.func
};
